<template>
    <header id="top" class="welcome">
        <NavBarStatic />
        <div class="welcome__front wrapper">
            <div class="welcome__front__content" :class="{visible: isFontReady && isImageReady}">
                <div class="welcome__front__content__logo">
                    <img id="logo" src="../assets/logo.png" alt=""  @load="isImageReady = true">
                </div>
                <div class="welcome__front__content__name">
                    <h1>TreeTopTrip</h1>
                    <p
                        data-aos="fade-up"
                        data-aos-delay="50"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-sine"
                        offset="500"
                        data-aos-once="true"
                        data-aos-anchor="#logo">
                        TreeTopTrip is a boutique software manufacturer
                        that delivers high quality solutions
                        for e-commerce, marketing, 
                        travel & accommodation, industry and others.
                    </p>
                </div>
            </div>
            <vk-spinner v-if="!isFontReady || !isImageReady" ratio="1.5"></vk-spinner>
        </div>
    </header>
</template>

<script>
    import NavBarStatic from './NavBarStatic'
    export default {
        name: 'welcome',

        data() {
            return {
                isFontReady: false,
                isImageReady: false,
            }
        },

        created() {
            document.fonts.ready.then(() => {
                this.isFontReady = true
            })
        },

        components: {
            NavBarStatic
        }
    }
</script>

<style lang="scss" scoped>

    .welcome {
        width: 100%;
        background-color: black;
        display: flex;
        justify-content: center;
        align-items: center;

        &__front {
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;

            .visible {
                opacity: 1;
            }

            .uk-icon.uk-spinner {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            &__content {
                display: flex;
                width: 100%;
                justify-content: center;
                opacity: 0;

                &__logo {
                    margin-right: 45px;
                    position: relative;

                    img {
                        max-height: 45vh;
                    }
                }

                &__name {
                    display: flex;
                    align-items: center;
                    position: relative;

                    h1 {
                        color: white;
                        margin: 0;
                        font-family: dubiel;
                        font-weight: 300;
                        font-size: 94px;
                    }

                    p {
                        color: white;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        max-width: 401px;
                        font-size: 1.2rem;
                        margin: 0 7px;
                        line-height: 35px;
                    }
                }
            }
        }
    }

    @media all and (max-height: 768px) {
        .welcome__front__content__name p {
            line-height: 26px;
        }
    }

    @media all and (max-width: 930px) {
        .welcome__front__content__name p {
            padding: 0;
        }
    }

    @media all and (max-width: 768px) {
        .welcome__front__content {
            flex-direction: column;
            align-items: center;

            &__logo {
                margin: 0;

                img {
                    max-height: 43vh;
                }
            }

            &__name {
                flex-direction: column;

                h1 {
                    font-size: 62px;
                    margin: 20px 0;
                }

                p {
                    position: initial;
                    text-align: center;
                    font-size: 15px;
                    padding: 0 20px;
                    line-height: 22px;
                }
            }
        }
    }

    @media all and (max-height: 700px) and (orientation: landscape) {
        .welcome__front__content__name {
            align-items: flex-start;

            h1 {
                padding-top: 20px;
                font-size: 72px;
            }
        }
    }

    @media all and (max-height: 520px) and (orientation: landscape) {
        .welcome__front__content__name {
            h1 {
                padding-top: 0px;
            }
        }
    }

    @media all and (max-width: 768px) {
        .welcome__front__content__name {
            align-items: center;
        }
    }

    @media all and (max-width: 820px) and (max-height: 600px) {
        .welcome__front__content {
            &__name {
                p {
                    width: 100%;
                }
            }
        }
    }

    @media all and (max-width: 820px) and (max-height: 420px) {
        .welcome__front__content {
            flex-direction: row;
            
            &__logo {
                margin-right: 40px;

                img {
                    max-height: 60vh;
                }
            }

            &__name {
                align-items: flex-start;
    
                h1 {
                    margin-top: 20px;
                    font-size: 72px;
                }
    
                p {
                    text-align: justify;
                    padding: 0;
                    max-width: 300px;
                    line-height: 24px;
                    font-size: 16px;
                }
            }
        }
    }

    @media all and (max-width: 820px) and (max-height: 380px) {
        .welcome__front__content__name {
            h1 {
                font-size: 56px;
            }

            p {
                    max-width: 235px;
                font-size: 12px;
            }
        }
    }

    @media all and (max-width: 570px) and (max-height: 330px) {
        .welcome__front__content__name p {
            line-height: 19px;
            font-size: 13px;
        }
    }

    @media all and (max-width: 380px) {
        .welcome__front__content__name {
            align-items: center;
            
            h1 {
                margin: 10px 0;
                font-size: 56px;
            }
            p {
                padding: 0 20px;
            }
        }
    }

    @media all and (max-width: 330px){
        .welcome__front__content__logo {
            img {
                max-height: 40vh;
            }
        }
    }

    @media all and (max-width: 380px) and (max-height: 450px) {
        .welcome__front__content {

            &__logo {
                margin-right: 20px;

                img {
                    max-height: 55vh;
                }
            }

            &__name {
                align-items: flex-start;
    
                h1 {
                    font-size: 42px;
                }
    
                p {
                    padding: 0;
                    max-width: 180px;
                    font-size: 10px;
                }
            }
        }
    }
</style>